/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Carriers API
 * Carrier-facing API for the carrier portal (carriers.freightsimple.com).  Authentication: a carrier opens a permanent signed login link, exchanges it for a session token, and presents that token as a bearer on every other call. `CarrierPortalAuthenticationFilter` validates the session and scopes each request to one carrier. Operations use `security: []` (no Micronaut JWT) — the filter is the authenticator, the same model the agents API uses.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { OpportunityAgreementStatus } from "./OpportunityAgreementStatus";
import {
  OpportunityAgreementStatusFromJSON,
  OpportunityAgreementStatusFromJSONTyped,
  OpportunityAgreementStatusToJSON,
  OpportunityAgreementStatusToJSONTyped,
} from "./OpportunityAgreementStatus";

/**
 *
 * @export
 * @interface OpportunitySummary
 */
export interface OpportunitySummary {
  /**
   *
   * @type {string}
   * @memberof OpportunitySummary
   */
  companyId: string;
  /**
   * Named, not anonymised. We are asking the carrier to price this
   * customer's freight, which they cannot do without knowing who it is.
   *
   * @type {string}
   * @memberof OpportunitySummary
   */
  companyName: string;
  /**
   * The FreightSimple rep's description of why this customer is a fit.
   * @type {string}
   * @memberof OpportunitySummary
   */
  narrative: string;
  /**
   * Shipments over the data window, annualised.
   * @type {number}
   * @memberof OpportunitySummary
   */
  shipmentsPerYear: number;
  /**
   * The customer's own estimate of what they spend on freight in a year
   * — their declared monthly figure times twelve. This is the customer's
   * total freight budget, not FreightSimple revenue.
   *
   * @type {number}
   * @memberof OpportunitySummary
   */
  estimatedAnnualFreightSpendCad?: number;
  /**
   * Share of this customer's shipments that fall inside this carrier's
   * service area, 0 to 1. Absent when we could not evaluate coverage.
   *
   * @type {number}
   * @memberof OpportunitySummary
   */
  coveragePercentage?: number;
  /**
   *
   * @type {OpportunityAgreementStatus}
   * @memberof OpportunitySummary
   */
  agreementStatus: OpportunityAgreementStatus;
  /**
   *
   * @type {string}
   * @memberof OpportunitySummary
   */
  agreementStatusLabel: string;
  /**
   *
   * @type {string}
   * @memberof OpportunitySummary
   */
  agreementId?: string;
  /**
   * Pre-formatted pricing expiry date, for a live agreement.
   * @type {string}
   * @memberof OpportunitySummary
   */
  expiresAt?: string;
  /**
   *
   * @type {boolean}
   * @memberof OpportunitySummary
   */
  expiringSoon?: boolean;
  /**
   * True once the carrier has registered interest.
   * @type {boolean}
   * @memberof OpportunitySummary
   */
  packageUnlocked: boolean;
  /**
   * True if this carrier already quotes this customer's shipments.
   * @type {boolean}
   * @memberof OpportunitySummary
   */
  alreadyQuoting: boolean;
  /**
   *
   * @type {number}
   * @memberof OpportunitySummary
   */
  quotedShipments?: number;
  /**
   * This carrier's win rate on this customer's freight, 0 to 1.
   * @type {number}
   * @memberof OpportunitySummary
   */
  winRate?: number;
  /**
   * This carrier's average price rank on this customer's freight.
   * @type {number}
   * @memberof OpportunitySummary
   */
  averageRank?: number;
}

/**
 * Check if a given object implements the OpportunitySummary interface.
 */
export function instanceOfOpportunitySummary(
  value: object,
): value is OpportunitySummary {
  if (!("companyId" in value) || value["companyId"] === undefined) return false;
  if (!("companyName" in value) || value["companyName"] === undefined)
    return false;
  if (!("narrative" in value) || value["narrative"] === undefined) return false;
  if (!("shipmentsPerYear" in value) || value["shipmentsPerYear"] === undefined)
    return false;
  if (!("agreementStatus" in value) || value["agreementStatus"] === undefined)
    return false;
  if (
    !("agreementStatusLabel" in value) ||
    value["agreementStatusLabel"] === undefined
  )
    return false;
  if (!("packageUnlocked" in value) || value["packageUnlocked"] === undefined)
    return false;
  if (!("alreadyQuoting" in value) || value["alreadyQuoting"] === undefined)
    return false;
  return true;
}

export function OpportunitySummaryFromJSON(json: any): OpportunitySummary {
  return OpportunitySummaryFromJSONTyped(json, false);
}

export function OpportunitySummaryFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): OpportunitySummary {
  if (json == null) {
    return json;
  }
  return {
    companyId: json["companyId"],
    companyName: json["companyName"],
    narrative: json["narrative"],
    shipmentsPerYear: json["shipmentsPerYear"],
    estimatedAnnualFreightSpendCad:
      json["estimatedAnnualFreightSpendCad"] == null
        ? undefined
        : json["estimatedAnnualFreightSpendCad"],
    coveragePercentage:
      json["coveragePercentage"] == null
        ? undefined
        : json["coveragePercentage"],
    agreementStatus: OpportunityAgreementStatusFromJSON(
      json["agreementStatus"],
    ),
    agreementStatusLabel: json["agreementStatusLabel"],
    agreementId: json["agreementId"] == null ? undefined : json["agreementId"],
    expiresAt: json["expiresAt"] == null ? undefined : json["expiresAt"],
    expiringSoon:
      json["expiringSoon"] == null ? undefined : json["expiringSoon"],
    packageUnlocked: json["packageUnlocked"],
    alreadyQuoting: json["alreadyQuoting"],
    quotedShipments:
      json["quotedShipments"] == null ? undefined : json["quotedShipments"],
    winRate: json["winRate"] == null ? undefined : json["winRate"],
    averageRank: json["averageRank"] == null ? undefined : json["averageRank"],
  };
}

export function OpportunitySummaryToJSON(json: any): OpportunitySummary {
  return OpportunitySummaryToJSONTyped(json, false);
}

export function OpportunitySummaryToJSONTyped(
  value?: OpportunitySummary | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    companyId: value["companyId"],
    companyName: value["companyName"],
    narrative: value["narrative"],
    shipmentsPerYear: value["shipmentsPerYear"],
    estimatedAnnualFreightSpendCad: value["estimatedAnnualFreightSpendCad"],
    coveragePercentage: value["coveragePercentage"],
    agreementStatus: OpportunityAgreementStatusToJSON(value["agreementStatus"]),
    agreementStatusLabel: value["agreementStatusLabel"],
    agreementId: value["agreementId"],
    expiresAt: value["expiresAt"],
    expiringSoon: value["expiringSoon"],
    packageUnlocked: value["packageUnlocked"],
    alreadyQuoting: value["alreadyQuoting"],
    quotedShipments: value["quotedShipments"],
    winRate: value["winRate"],
    averageRank: value["averageRank"],
  };
}
